export default __webpack_public_path__ + "static/media/loading-animation.c117ed9a.svg";